import React from "react";
import { Helmet } from "react-helmet-async";

const HelmetSEO = ({
  title,
  description,
  canonical,
  noIndex = false,
}) => {
  return (
    <Helmet>
      {title ? <title>{title}</title> : null}
      {description ? <meta name="description" content={description} /> : null}
      {canonical ? <link rel="canonical" href={canonical} /> : null}
      <meta
        name="robots"
        content={
          noIndex
            ? "noindex, nofollow"
            : "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1"
        }
      />
    </Helmet>
  );
};

export default HelmetSEO;
